import { VisitPrescriptionPackageQuery } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { Direction, paginations } from '@dreryk/command-query-ws-client';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { PrescriptionPackage } from '~libs.shared.prescription';

import { prescriptionsTranslationKeys } from '../../../translations';
import { VisitId } from '../PrescriptionIssuingPanel.types';

type PrescriptionsPanelLoaderRenderProps = {
   prescriptionPackages: PrescriptionPackage[];
   setPrescriptionPackages: (prescriptionPackages: PrescriptionPackage[]) => void;
};

type PrescriptionsPanelLoaderProps = {
   readonly visitId: VisitId;
   readonly children: (renderProps: PrescriptionsPanelLoaderRenderProps) => JSX.Element;
};

export const PrescriptionsPanelLoader = (props: PrescriptionsPanelLoaderProps): JSX.Element => {
   const {
      data: prescriptionPackages,
      setData: setPrescriptionPackages,
      loading: prescriptionPackagesLoading,
      error: prescriptionPackagesError,
   } = useCqrsSearch<PrescriptionPackage>(() => {
      const query = new VisitPrescriptionPackageQuery();
      query.visitId = props.visitId;
      return query;
   }, paginations.all<PrescriptionPackage>().orderedBy('id', Direction.DESCENDING));

   if (prescriptionPackagesLoading) {
      return <LoaderSpinner />;
   }

   if (prescriptionPackagesError) {
      return (
         <Message
            testId={'failedToFetchPrescriptions'}
            label={prescriptionsTranslationKeys.failedToFetchPrescriptions}
            type={MessageType.NEGATIVE}
            displayIndicator
            fullWidth
         />
      );
   }

   return props.children({
      prescriptionPackages: prescriptionPackages,
      setPrescriptionPackages: setPrescriptionPackages,
   });
};
